import React from 'react';
import {
  Wrapper,
  RelativePostItem,
  PostTitle,
} from './styles/RelativePosts.styles';
import { useLanguage } from '../../locales';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import { BsArrowReturnLeft, BsArrowReturnRight } from 'react-icons/bs';
const RelationPosts = ({ post }) => {
  const { translation, lang } = useLanguage();
  const justifyContent =
    post.nextPost && post.prevPost
      ? 'space-between'
      : post.nextPost && !post.prevPost
      ? 'flex-end'
      : 'flex-start';

  if (!post.nextPost && !post.prevPost) return null;

  return (
    <Wrapper justify={justifyContent}>
      {post.prevPost && (
        <RelativePostItem
          to={`/posts/${post.prevPost.slug}`}
          onClick={() => {
            trackCustomEvent({
              category: 'post',
              action: 'click',
              label: post.prevPost.slug,
            });
          }}
        >
          <h4>{post.prevPost[`title_${lang}`]}</h4>
          <BsArrowReturnLeft />
        </RelativePostItem>
      )}
      {post.nextPost && (
        <RelativePostItem
          to={`/posts/${post.nextPost.slug}`}
          onClick={() => {
            trackCustomEvent({
              category: 'post',
              action: 'click',
              label: post.nextPost.slug,
            });
          }}
        >
          <h4>{post.nextPost[`title_${lang}`]}</h4>
          <BsArrowReturnRight />
        </RelativePostItem>
      )}
    </Wrapper>
  );
};

export default RelationPosts;
